type Resume = () => void
let prepare: (() => Promise<Resume | void> | Resume | void) | null = null
export function setLocalSessionCloseHandler(handler: typeof prepare): void { prepare = handler }
export async function prepareLocalSessionClose(): Promise<Resume> { return await prepare?.() || (() => {}) }
